module.exports = __webpack_public_path__ + "img/icon6.8c48206.png";